import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth/AuthProvider";
import { AppRouter } from "./routes/router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime 30 s — SPEC-009 §8 risk: avoid N+1 on 7/30/90 toggle.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err: unknown) => {
        // Don't retry 4xx — they're terminal (auth / not-found / 409 etc).
        if (
          err &&
          typeof err === "object" &&
          "status" in err &&
          typeof (err as { status: unknown }).status === "number"
        ) {
          const s = (err as { status: number }).status;
          if (s >= 400 && s < 500) return false;
        }
        return count < 2;
      },
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </QueryClientProvider>
  );
}
